import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import {
  BgOverlay,
  Container,
  Content,
  Section,
} from '../styles/SharedBlockStyledComponents';

export default function BlockProductHardcoded() {
  return (
    <>
      <Section className="relative mt-16">
        <Container>
          {/* bg photo */}
          <StaticImage
            src="../images/home-bg-6.png"
            alt="Background"
            className="bg--photo"
              style={{
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100%',
              height: '100%',
              zIndex: 1,
            }}
            placeholder="none"
            layout="fullWidth"
          />

          {/* darken the photo with an overlay */}
          <BgOverlay />

          {/* show content */}
          <Content className="product-page">
            <h1 className="h1">Built for transit</h1>
            <h3 className="h3">
              One platform to run your on-demand, flex, fixed, and paratransit
              services
            </h3>
          </Content>
        </Container>
      </Section>
      {/* <Section className="relative">
        <Container>
          <StaticImage
            src="../images/home-bg-5.jpg"
            alt="Background"
            className="bg--photo"
            style={{
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '100%',
              height: '100%',
              zIndex: 1,
            }}
            placeholder="none"
            layout="fullWidth"
          />
          <Content className="homepage-zoox" $maxWidth="1120px">
            <div
              style={{
                background: 'rgba(0,0,0,0.45)',
                padding: '2.5rem',
                display: 'inline-block',
                boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
              }}
            >
              <h2
                className="h2 mb-4"
                style={{
                  color: '#fff',
                  textShadow: '0 2px 8px rgba(0,0,0,0.25)',
                }}
              >
                Zoox enters into a <br /> non-exclusive technology <br />{' '}
                license agreement with TRC
              </h2>
              <a href="/contact" className="btn--rounded bg--tan mt-16">
                Get in touch about licensing our products
              </a>
            </div>
          </Content>
        </Container>
      </Section> */}
    </>
  );
}
